import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

import AddUpdateClinicUser from "./addUpdateClinicUser";
import Table from "../../common/Table/table";
import {
  createClinicUser,
  getClinicUserByIdSlice,
  updateClinicUser,
  deleteClinicUser,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
} from "../../../store/slices/clinicUserSlice";

import { getAllClinic } from "../../../store/slices/clinicSlice";
import { getRoleSlice } from "../../../store/slices/roleSlice";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const ClinicUser = () => {
  const dispatch = useDispatch();
  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteClinic, setDeleteclinic] = useState(null);
  const [showStatus, setShowStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [inputError, setInputError] = useState({
    email: false,
    phNumber: false,
    name: false,
  });
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    phone: "",
    clinicId: "",
    userId: "",
    email: "",
    userType: "",
    role: [],
    password: "",
    isAdmin: false,
    status: "Active",
  });
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    createclinicUserSuccessMessage,
    createclinicUserErrorMessage,
    updateclinicUserSuccessMessage,
    updateclinicUserErrorMessage,
    deleteclinicUserSuccessMessage,
    deleteclinicUserErrorMessage,
    clinicUser,
  } = useSelector((state) => state.clinicUser);
  const { token } = useSelector((state) => state.auth);
  const {
    clinicInfo,
    allClinicLists,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.clinic);
  const { roles } = useSelector((state) => state.role);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const clinicId = clinicInfo?.[0]?.clinicId ;
  useEffect(() => {
    dispatch(
      getRoleSlice({
        applicationCustomId: 2,
        status: ["Active"],
        token,
        clinicId,
      }),
    );
  }, [dispatch, token, clinicId]);

  useEffect(() => {
    showTostifyMessageAndReset(
      createclinicUserSuccessMessage,
      showToastifySuccess,
      resetCreateMessages,
    );
    showTostifyMessageAndReset(
      createclinicUserErrorMessage,
      showToastifyError,
      resetCreateMessages,
    );
    showTostifyMessageAndReset(
      updateclinicUserSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages,
    );
    showTostifyMessageAndReset(
      updateclinicUserErrorMessage,
      showToastifyError,
      resetUpdateMessages,
    );
    showTostifyMessageAndReset(
      deleteclinicUserSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages,
    );
    showTostifyMessageAndReset(
      deleteclinicUserErrorMessage,
      showToastifyError,
      resetDeleteMessages,
    );
  }, [
    createclinicUserSuccessMessage,
    createclinicUserErrorMessage,
    updateclinicUserSuccessMessage,
    updateclinicUserErrorMessage,
    deleteclinicUserSuccessMessage,
    deleteclinicUserErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const fetchClinicUser = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (!clinicId) return;

      dispatch(
        getAllClinic({
          clinicId,
          status: tableStatus,
          loginRole: "ClinicUser",
          token,
          currentPage: page,
          limit: lim,
          name: search,
        }),
      );
    },
    [dispatch, token, clinicId, tableStatus, searchValue, pageLimit],
  );
  useEffect(() => {
    fetchClinicUser();
  }, [fetchClinicUser, showModal, showDeleteModal, showGlobalViewModal]);
  useEffect(() => {
    fetchClinicUser();
  }, [fetchClinicUser, showModal, showDeleteModal, showGlobalViewModal]);

  const handlePageChange = (page) => {
    fetchClinicUser(page, pageLimit, searchValue);
  };
  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchClinicUser(1, newLimit, searchValue);
  };
  const tableHead = [
    { title: "Name", key: "name" },
    { title: "Email", key: "email" },
    { title: "Phone", key: "phone" },
    { title: "User Type", key: "userType" },
    { title: "Role", key: "role" },
    { title: "Status", key: "status" },
  ];

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleModal = (action, clinicUser = null) => {
    if (action === "create") {
      setFormData({
        id: "",
        name: "",
        phone: "",
        email: "",
        password: "",
        clinicId,
        userType: 7,
        role: clinicUser?.role[0]?._id,
        loginRole: "ClinicUser",
        isAdmin: false,
        status: "Active",
      });
    } else if (action === "edit" && clinicUser) {
      setFormData({
        id: clinicUser?._id,
        clinicId,
        userId: clinicInfo[0]?.userId?._id,
        name: clinicUser?.userId?.name,
        phone: clinicUser?.userId?.phone,
        email: clinicUser?.userId?.email,
        userType: 7,
        role: clinicUser?.role[0]?._id,
        password: clinicUser?.password,
        status: clinicUser?.status,
        loginRole: "ClinicUser",
        isAdmin: clinicUser?.isAdmin,
      });
    }
    setModalVisible(true);
    setModalAction(action);
  };
  const handleAddOrUpdateAccount = async (e) => {
    e.preventDefault();
    const newRoleId = formData?.role?.map((data) => data.value);
    const { name, email, phNumber } = inputError;
    if (name || email || phNumber) {
      return;
    }

    try {
      if (modalAction === "create") {
        await dispatch(
          createClinicUser({ ...formData, role: newRoleId, token }),
        );
      } else {
        await dispatch(
          updateClinicUser({
            id: formData?.id,
            clinicId,
            userId: clinicInfo[0]?.userId?._id,
            name: formData?.name,
            role: newRoleId,
            password: formData?.password,
            userType: 7,
            email: formData?.email,
            phone: formData?.phone,
            status: formData?.status,
            isAdmin: formData?.isAdmin,
            loginRole: "ClinicUser",
            token,
          }),
        );
        fetchClinicUser();
      }
      setModalVisible(false);
      setFormData({
        id: "",
        name: "",
        phone: "",
        email: "",
        userType: "",
        role: [],
        password: "",
        status: "Active",
      });
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const updateData = {
        id: item?.id,
        status: status,
        clinicId,
        userId: clinicInfo[0]?.userId?._id,
        token,
      };
      await dispatch(updateClinicUser(updateData));
      if (clinicId) {
        fetchClinicUser();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchClinicUser(1, pageLimit, value);
    },
    [fetchClinicUser, pageLimit],
  );

  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getClinicUserByIdSlice({
        id: data?.id,
        clinicId,
        token,
      }),
    );
    setShowGlobalViewModal(true);
  };

  const handleEdit = (clinicUser) => {
    handleModal("edit", clinicUser);
    const newRole = clinicUser?.roleList?.map((data) => ({
      value: data?.value,
      label: data?.label,
    }));
    setFormData({
      id: clinicUser?.id,
      clinicId,
      name: clinicUser?.name,
      phone: clinicUser?.phone,
      email: clinicUser?.email,
      userType: clinicUser?.userType,
      role: newRole,
      roleName: clinicUser?.roleId,
      isAdmin: clinicUser?.isAdmin,
      status: clinicUser?.status,
    });
  };
  const handleDeleteclinicUser = async () => {
    try {
      await dispatch(
        deleteClinicUser({
          id: deleteClinic,
          clinicId,
          token,
        }),
      );
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const handleDelete = (Id) => {
    setDeleteclinic(Id.id);
    setDeleteModalVisible(true);
  };

  const handleRoleChange = (item) => {
    const newItem = item || [];
    const filterOption = newItem?.map((data) => ({
      value: data?.value,
      label: data?.label,
    }));
    setFormData({
      ...formData,
      role: filterOption,
    });
  };

  
  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          allClinicLists &&
          allClinicLists?.map((item) => ({
            id: item?._id,
            clinicId: item?.clinicId,
            name: item?.userId?.name,
            email: item?.userId?.email,
            phone: item?.userId?.phone,
            userType: item?.loginRole,
            isAdmin: item?.isAdmin,
            roleList: item?.role?.map((data) => ({
              value: data?._id,
              label: data?.name,
            })),
            role: item?.role?.map((data) => data?.name?.toString()).join(", "),
            status: item?.status,
          }))
        }
        addModal={() => handleModal("create")}
        handleEdit={handleEdit}
        searchValue={searchValue}
        handleSearch={handleSearch}
        handleDelete={handleDelete}
        handleDeleteclinicUser={handleDeleteclinicUser}
        errorMessage={searchMessage}
        handleAddBtn={true}
        handleSearchOption={true}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      <AddUpdateClinicUser
        showModal={showModal}
        searchValue={searchValue}
        setModalVisible={setModalVisible}
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        modalAction={modalAction}
        handleAddOrUpdateAccount={handleAddOrUpdateAccount}
        handleRoleChange={handleRoleChange}
        roles={roles}
        setInputError={setInputError}
        clinicInfo={clinicInfo}
      />

      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete AccountType</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this clinicUser?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeleteclinicUser}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={tableHead}
        content={{
          id: clinicUser._id,
          name: clinicUser?.user?.name,
          email: clinicUser?.user?.email,
          phone: clinicUser?.user?.phone,
          userType: clinicUser?.user?.userType[0]?.type,
          role: clinicUser?.roles?.map((role) => role.name).join(", "),
          status: clinicUser?.clinicUser?.status,
        }}
      />
    </div>
  );
};

export default ClinicUser;
